<template>
  <div class='notice atb-flex atb-flex-column'>
    <div class='search-wrap'>
      <el-form :inline="true" :model="declareForm" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="form-param-item" label="姓名">
            <selecter v-model="declareForm.WkName" clearable @selecterData="getSelecterData"></selecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item v-if="!this.wkNo && !this.msgId">
            <el-button type="primary" @click="showAmendment">修订</el-button>
          </el-form-item>
          <el-form-item v-if="!this.wkNo && !this.msgId && $auth(that, 'Commit')">
            <el-button type="export" @click="commitTip">提交</el-button>
          </el-form-item>
          <el-form-item v-if="!this.wkNo && !this.msgId">
            <el-button type="refuse" @click="showRevert = true">撤回</el-button>
          </el-form-item>
          <el-form-item v-if="!this.wkNo && !this.msgId">
            <el-button type="downloadTemplate" @click="showApproveReason = true">审批意见</el-button>
          </el-form-item>
          
          <el-form-item v-if="this.wkNo && this.msgId">
            <el-button :disabled="this.role == 2" type="primary" @click="showAccess = true">通过</el-button>
          </el-form-item>
          <el-form-item v-if="this.wkNo && this.msgId">
            <el-button :disabled="this.role == 2" type="refuse" @click="showRefuse = true">驳回</el-button>
          </el-form-item>
      </el-form>
    </div>

    <div class='table-content'>
      <vxe-table
        stripe
        class='atb-table header-table edit-table'
        border='inner'
        height='100%'
        auto-resize
        highlight-hover-row
        highlight-current-row
        :data="tableData"
        ref="unHandle"
        :edit-rules="validRules"
        :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
        @edit-closed="editClosed"
        @cell-click="expandRow"
        :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true}"
      >
        <vxe-table-column type="seq" min-width="60" title="NO."></vxe-table-column>
        <vxe-table-column field="wk" min-width="300" title="姓名">
            <template #default="{ row }">
            <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="superior" min-width="185" title="上级">
          <template #default="{ row }">
            <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
        <vxe-table-column field="date" title="年/月" width="80">
          <template #default="{row}">{{row.year+'/'+row.month}}</template>
        </vxe-table-column>
        <vxe-table-column width="90" field="ratingResult" title="OEC评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
          <template #default="{row}">
            <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
            <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
            <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
          </template>
          <template #edit="{row}">
            <el-select v-model="row.ratingResult" @change="$refs.unHandle.updateStatus(scope)">
              <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column width="115" field="isRatingInCurrentMonth" title="当月是否参评">
          <template #default="{row}">
            <span>{{row.isRatingInCurrentMonth ? "是" : '否'}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
          <template #edit="{ row }">
            <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
          </template>
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
          <template #edit="{ row }">
            <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
          </template>
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="status" title="状态" min-width="95" fixed="right">
          <template #default="{ row,column }">
            <el-tag :type="row.status == 0 ? 'unstart' : (row.status == 20 ? 'complete' : 'ongoing') " effect="dark">
              {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row[column.property])? OecStatusList.find(t=>t.itemValue==row[column.property]).itemDesc: '' }}
            </el-tag>
          </template>
        </vxe-table-column>
        <vxe-table-column field="" title="操作" class-name='operation' width="60" fixed="right">
          <template #default="{ row }">
            <el-tooltip class='item' effect='dark' content='删除' placement="bottom" v-if="row.status === 0 || row.status === 5">
              <i class='icon-close delete' @click.stop='deleteRow(row)'></i>
            </el-tooltip>
          </template>
        </vxe-table-column>
        
      </vxe-table>
    </div>
    <div class='page-con atb-flex atb-flex-justify-end'>
      <vxe-pager
        background
        :current-page.sync="page.PageIndex"
        :page-size.sync="page.PageSize"
        :total="total"
        height="100%"
        @page-change="pageChange"
        :page-sizes="[10, 30, 50, 100, 500]"
        :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
      >
      </vxe-pager>
    </div>

    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmHandle">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showCommitTip" width="300px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要提交吗?</h2>
        <p>提交之后不能修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCommitTip = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showAccess"
      width="500px"
      @close="closeAccess"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="请填写审批通过原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showAccess = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showRefuse"
      width="500px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="请填写审批驳回原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showRefuse = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showApproveReason"
      width="500px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <p style="text-align:left;line-height: 18px;">{{approveReasonText || '无'}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-cancel" type="primary" @click="showApproveReason = false">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="showRevert"
      width="300px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <h2>确定要撤回当前申报吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="revert()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showRevert = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修订"
      :visible.sync="amendmentDialogVisible"
      width="900px"
      @close="closeAmendment"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="amendment-form-wrap">
        <el-form label-width="0px">
          <el-form-item label="" prop="wkNo">
            <el-input type="text" v-model="amendmentFilterQuery" autocomplete="on" class="amendment-search-input" placeholder="姓名/工号，搜索表格数据" clearable></el-input>
            <el-button type="primary" class="amendment-search-btn" native-type="submit" @click.prevent="amendmentSearch" plain>搜索</el-button>
          </el-form-item>
        </el-form>
        <vxe-table
          row-key
          column-key
          show-overflow
          show-header-overflow
          highlight-hover-row
          highlight-current-row
          auto-resize
          height="360"
          v-loading="loading"
          ref="amendmentTable"
          :scroll-y="{gt: 50, oSize: 5}" 
          :data="amendmentTableFilterData"
          :keyboard-config="{isArrow: true}"
          :checkbox-config="{trigger: 'row'}"
        >
          <vxe-column type="checkbox" width="60"></vxe-column>
          <vxe-column type="seq" title="序号" width="100"></vxe-column>
          <vxe-column field="wk" width="160" title="姓名">
              <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-column>
          <!-- <vxe-column field="superior" min-width="160" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-column> -->
          <vxe-column field="ratingResult" title="评定结果" width="100">
             <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
          </vxe-column>
          <vxe-column field="department" title="部门" min-width="220"></vxe-column>
        </vxe-table>
        <div class="atb-text-right" style="margin-top: 10px;">
          <!-- 保存 -->
          <el-button class="atb-dialog-confirm" type="primary" @click="amendmentSubmit" style="margin-left: 0;">保存</el-button>
          <!-- 取消 -->
          <el-button class="atb-dialog-cancel" type="cancel" @click="amendmentDialogVisible = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash';

  export default {
    name: "DeclareResultAmendment",
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      month:()=>import('./month.vue'),
    },
    inject: ['reload'],
    data() {
      const ratingReasonValid = ({cellValue, row}) => {
        if (!cellValue && ['A', 'C'].includes(row.ratingResult)) {
          return new Error('评级结果为A、C时必须填写原因！')
        }
      }
      return {
        validRules: {
          ratingReason: [
            {validator: ratingReasonValid}
          ]
        },
        XEUtils: XEUtils,
        activeName: 'second',
        currentTab: 0,
        showHandle: false,
        handleDelete: true,
        enableHandle: true,
        importantList: [
          {label: '否', value: false},
          {label: '是', value: true},
        ],
        oecLevel: [
          {label: 'A'},
          {label: 'B'},
          {label: 'C'},
        ],
        declareForm: {
          isSub: true,
          WkName: ''
        },
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
        OecStatusList: [],
        that: this,
        row: {},
        showCommitTip: false,
        message: '',
        currWkNo: '',
        editJson: {},
        cacheEditJson: {},
        errMap: 1,
        wkNo: '',
        msgId: '',
        showAccess: false,
        showRefuse: false,
        showRevert: false,
        showApproveReason: false,
        approveReason: '',
        role: 1,
        approveReasonText: '',
        status: '',
        month: '',

        amendmentDialogVisible: false,
        amendmentTableData: [],
        amendmentTableFilterData: [],
        amendmentFilterQuery: '',
      }
    },
    created() {
      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.role = this.$route.query.role || 1;
      this.date = this.$route.query.date || '';
    },
    mounted() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';

      this.getList();
      this.getOecStatus();
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      async getList(resetPage) {
        if (resetPage) {
          this.page.PageIndex = 1;
        }
        if (this.wkNo) {
          this.currWkNo = this.wkNo;
        }
        let param = {};
        this.declareForm.wkNo = this.currWkNo;
        this.declareForm.Date = this.date;

        param = (this.declareForm.WkNo || this.declareForm.SuperiorNo) ? Object.assign({}, this.page, this.declareForm) : Object.assign({}, this.page, this.declareForm);
        await this.$ajax.get(this.$api.manage.declare.amendmentList, param).then(async(res) => {
          this.tableData = res.data.rows && res.data.rows.map(p => {
            p.parentId = null;
            p.hasChild = p.isOrLeader ? true : false;
            return p
          });
          if (this.tableData && this.tableData.length > 0) {
            this.approveReasonText = this.tableData[0].approveReason;
            this.status = this.tableData[0].status;
            this.month = this.tableData[0].year + '-' + this.tableData[0].month;
          }
          this.total = res.data.total;
        });
      },

      async editClosed({row}) {
        this.errMap = null;
        this.editJson = JSON.parse(JSON.stringify(row));
        const currVal = {ratingResult: row.ratingResult, ratingReason: row.ratingReason, remarks: row.remarks};
        if (JSON.stringify(this.cacheEditJson) === JSON.stringify(currVal)) {
          this.errMap = 1;
          return;
        }
        const $table = this.currentTab === 0 ? this.$refs.unHandle : this.$refs.queryDeclareResult;
        this.errMap = await $table.validate(row).catch(errMap => errMap)
        if (!this.errMap) {
          this.errMap = 1;
          const {id, ratingResult, ratingReason, remarks, status} = row;
          const loginWkNo = this.currWkNo;
          this.$ajax.post(this.$api.manage.declare.amendmentSaveInfo, [{id, ratingResult, ratingReason, remarks, status, loginWkNo}]).then(async() => {
            this.$message.success("保存成功");
          });
        }
      },
      editActived({row}) {
        if (this.msgId && this.wkNo) {
          return false
        }
        if ((row.status === 0 || row.status === 5) && this.errMap) {
          const preVal = {ratingResult: row.ratingResult, ratingReason: row.ratingReason, remarks: row.remarks};
          this.cacheEditJson = JSON.parse(JSON.stringify(preVal));
          return true;
        }
        return false;
      },
      commitTip() {
        this.$nextTick(async () => {
          const $table = this.currentTab === 0 ? this.$refs.unHandle : this.$refs.queryDeclareResult;
          const errMap = await $table.validate(true).catch(errMap => errMap)
          if (!errMap) {
            this.showCommitTip = true;
          }
        })
      },
      submit() {
        const WkNo = this.currWkNo;
        this.$ajax.get(this.$api.manage.declare.amendmentCommit, { WkNo: WkNo }).then(() => {
          this.getList();
          this.$message.success("提交成功");
        }).finally(() => {
          this.showCommitTip = false;
        });
      },
      revert() {
        this.showRevert = false;
        this.$ajax.put(this.$api.manage.declare.amendmentRevert, {sendNo: this.currWkNo}).then(() => {
          this.getList();
          this.$message.success("撤回成功");
        });
      },
      pageChange({currentPage}) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
  
      async getOecStatus() {
        await this.$ajax.get(this.$api.common.getDict, {ItemType: 'OecModifyStatus'}).then((res) => {
          this.OecStatusList = res.data.rows || res.data || [];
        });
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row, triggerTreeNode}) {
        if (triggerTreeNode) return;
        row.expandRowFlag = !row.expandRowFlag;
        this.$refs.unHandle.updateData(this.tableData);
      },


      approve(action) {
        let param = {
          wkNo: this.wkNo,
          MsgId: this.msgId,
          Remark: this.approveReason
        };
        if (action === "access") {
          param.status = 10;
          this.showAccess = false;
        } else {
          param.status = 0;
          if (!this.approveReason) {
            this.$message.error("必须填写驳回原因！");
            return false;
          }
          this.showRefuse = false;
        }
        this.$ajax.get(this.$api.manage.declare.amendmentUpdateStatus, param).then(() => {
          this.$message.success("审批成功");
          this.role = 2;
        }).finally(() => {
          this.reload();
        });
      },
      closeRefuse() {
        this.approveReason = '';
      },
      closeAccess() {
        this.approveReason = '';
      },
      showAmendment() {
        this.$ajax.get(this.$api.manage.declare.isAmendment, { loginWkNo: this.currWkNo }).then((res) => {
          this.amendmentDialogVisible = true;
          if (res.data) {
            this.amendmentTableFilterData = this.amendmentTableData = res.data || [];
          }
        });
      },
      closeAmendment() {
        this.amendmentTableFilterData = this.amendmentTableData = [];
      },
      // 添加用户时，获取所有用户，打开弹窗，选择用户
      amendmentSearch() {
        const self = this;
        const tableAllData = this.amendmentTableData;
        this.loading = true;      

        const endFn = function() {
          self.loading = false;
          setTimeout(() => {
            self.$refs['amendmentTable'] && self.$refs['amendmentTable'].scrollTo(0, 0);
          }, 0)
        }

        this.amendmentTableFilterData = tableAllData.filter(v => {
          let reg = new RegExp(this.amendmentFilterQuery, 'gi');
          return reg.test(v.wkName) || reg.test(v.wkNo);
        })
        endFn();
      },

      amendmentSubmit() {
        const selectList = this.$refs.amendmentTable.getCheckboxRecords();
        this.$ajax.post(this.$api.manage.declare.amendmentSave, selectList).then(() => {
          this.$message.success('保存成功');
          this.amendmentDialogVisible = false;
          this.getList(1);
        });
      },
      deleteRow(row) {
        //用户提示选择，删除为敏感操作
        this.$confirm(this.DeleteText || this.$t('common.DeleteText'), this.Tips || this.$t('common.Tips') ,{
          type: 'warning',
          cancelButtonText: this.$t('common.Cancel'),
          confirmButtonText: this.$t('common.Done')
        }).then(() => {//用户选择删除
          //组合删除接口参数
          var deleteParam = {id: row.id};
          //调用接口
          this.$ajax.get(this.$api.manage.declare.amendmentDelete, deleteParam).then(response=>{
            if(response.code == this.$config.ResultCode.SUCCESS_CODE || !response.error){
              //删除成功提示
              this.$message({
                type: 'success',
                message: this.$t('common.DeleteSuccess')
              });
              this.getList();
            }
          }).catch(()=>{ })
        }).catch(()=>{ });
      },
    },
  }
</script>
<style scoped lang='scss'>
  .notice {
    .search-wrap {
      .atb-input {
        display: flex;
        .form-param-item {
          width: 20%;
          ::v-deep .el-form-item__content {
            width: calc(100% - 50px);
            .customerSelect {
              width: 100%;
            }
          }
        }
      }
    }
    .search {
      .atb-input {
        display: flex;
        flex-direction: column;
        .query-where {
          display: flex;
          .flex-form-item {
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
        }
      }
    }
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab {
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    .amendment-form-wrap {
      text-align: left;
      .amendment-search-input {
        width: 320px;
        .el-input__inner {
          border-top-right-radius: 0; 
          border-bottom-right-radius: 0; 
        }
      }
      .amendment-search-btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
</style>
